var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"error-log-badge"},[_c('el-badge',{staticClass:"badge layout-svg-btn",attrs:{"value":_vm.count,"max":99,"hidden":_vm.count === 0}},[_c('el-button',{attrs:{"size":"small","plain":""},on:{"click":_vm.openErrorLogger}},[_c('svg-icon',{attrs:{"name":"bug","width":"20px","height":"20px"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }